"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M10 6a6 6 0 106 6h-6V6zm-.998-1.938A1.015 1.015 0 019 4V2H7a1 1 0 110-2h6a1 1 0 010 2h-2v2c0 .02 0 .041-.002.062A8.001 8.001 0 0110 20a8 8 0 01-.998-15.938z"];
//# sourceMappingURL=stopwatch.js.map